export const featureFlags = {
  // Gates only the Vetting drawer "Interview first" button: the endpoint
  // records the request and emails the candidate, but no ATS (Greenhouse /
  // Lever / Workday) receives it, so the button stays hidden until it does.
  ENABLE_INTEGRATIONS: false,
  ENABLE_CUSTOM_THEME: false,
  // Timezone + date-format preferences. Persisted but not yet applied to
  // date rendering (no shared `formatDate(date, { locale, tz, format })`
  // helper). Flip this on once a formatter lands and call sites adopt it.
  ENABLE_LOCALIZATION_PREFS: false,
  ENABLE_EXTENDED_MESSAGE_CHANNELS: false,
  ENABLE_ASK_TONNIE_SERVICES: false,
  ENABLE_2FA: false,
  // Messages → Channels: per-channel Configure/Test actions and the
  // "Channel Integrations" docs/help box. The configure/test flows aren't
  // wired in R1 (even for the Connected Email channel), so hide the controls
  // rather than expose dead buttons. Flip on when channel config ships.
  ENABLE_MESSAGE_CHANNEL_CONFIG: false,
  // Onboarding — R1 evolution
  ENABLE_ONBOARDING_ADD_TALENTS_STEP: false,
  ENABLE_ONBOARDING_LEGACY_FIELDS: false,
  /**
   * Dashboard — `<NextBestActions />` widget (AI-recommended top
   * actions list). Overlaps semantically with the shipped
   * `<TodayPanel />`; defer to a follow-up that decides whether to
   * merge or run them in parallel. Default OFF so the dashboard
   * stays single-truth on TodayPanel for R1.
   */
  ENABLE_DASHBOARD_NEXT_BEST_ACTIONS: false,
  /**
   * Dashboard — `<WeeklySummary />` digest card. Mockup positions
   * it beside NextBestActions. Defer until the activity feed gets
   * a weekly rollup endpoint; the current SDK only exposes the
   * 5-event activity feed used by the Recent Activity card.
   */
  ENABLE_DASHBOARD_WEEKLY_SUMMARY: false,

  /**
   * First-access intro carousel.
   *
   * Controls the welcome/onboarding intro carousel shown once on the first
   * authenticated visit. "Seen" state is persisted per-user (cross-device) in
   * `users.settings.preferences.business.introCarouselVersion`. Bump
   * INTRO_CAROUSEL_VERSION to re-surface it after a content change.
   *
   * OFF by default (prod); opt-in via `VITE_ENABLE_INTRO_CAROUSEL=true`
   * (used by the e2e build so Playwright can exercise it without shipping
   * it enabled).
   */
  ENABLE_INTRO_CAROUSEL: import.meta.env.VITE_ENABLE_INTRO_CAROUSEL === 'true',
} as const;

/**
 * Well-known Tonnie internal tenant id (BL-207) — the fixed sentinel seeded by
 * migration 0092 and defaulted in env-schemas. NOT a secret; used FE-side to
 * gate the Tonnie-ops full-profile Pool import surface to that tenant. The
 * backend independently enforces the same check (403 otherwise).
 */
export const TONNIE_INTERNAL_TENANT_ID = '00000000-0000-4000-8000-000000000001';

export type FeatureFlag = keyof typeof featureFlags;

export function isFeatureEnabled(flag: FeatureFlag): boolean {
  return featureFlags[flag];
}
